export const validationMessages = {
  required: 'This field is required',
  urlTaken: 'This URL is already used',
  similarBotName: 'There is already a bot with similar name'
};
